var _require = require('./errors'),
  ContentError = _require.ContentError;
var _require2 = require('./validators'),
  isTypeOf = _require2.isTypeOf,
  isInstanceOf = _require2.isInstanceOf,
  isEmail = _require2.isEmail;
var validate = {
  typeOf: function typeOf(type, target) {
    if (!isTypeOf(target, type)) throw new TypeError("".concat(target, " is not a ").concat(type));
  },
  string: function string(target) {
    this.typeOf('string', target);
  },
  function: function _function(target) {
    this.typeOf('function', target);
  },
  number: function number(target) {
    this.typeOf('number', target);
  },
  boolean: function boolean(target) {
    this.typeOf('boolean', target);
  },
  instanceOf: function instanceOf(type, target) {
    if (!isInstanceOf(target, type)) throw TypeError("".concat(target, " is not a ").concat(type.name));
  },
  array: function array(target) {
    this.instanceOf(Array, target);
  },
  date: function date(target) {
    this.instanceOf(Date, target);
  },
  email: function email(target) {
    if (!isEmail(String(target).toLowerCase())) throw new ContentError("".concat(target, " is not an e-mail"));
  },
  matches: function matches(name, target) {
    for (var _len = arguments.length, values = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      values[_key - 2] = arguments[_key];
    }
    if (!values.includes(target)) throw new ContentError("".concat(target, " does not match any of the valid ").concat(name, " values: ").concat(values));
  }
};
validate.string.notVoid = function (name, target) {
  if (!target.trim().length) throw new ContentError("".concat(name, " is empty or blank"));
};
module.exports = validate;